import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from './../../../../Containers/Config/index';
import { BENEFIT_PACK_INFO, BENEFIT_PACK_INFO_SUCCESS, BENEFIT_PACK_INFO_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getBenefitPackInfo({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/benefitPacksInfo`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        ...payload?.urlParam,
        pageSize: Constant?.TABLE_PAGE_SIZE,
      },
    });

    if (response.status === 200) {
      yield put({
        type: BENEFIT_PACK_INFO_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: BENEFIT_PACK_INFO_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: BENEFIT_PACK_INFO_ERROR, payload: error });
  }
}

export function* watchBenefitPackInfo() {
  yield takeEvery(BENEFIT_PACK_INFO, getBenefitPackInfo);
}

function* benefitPackInfoSaga() {
  yield all([fork(watchBenefitPackInfo)]);
}

export default benefitPackInfoSaga;
